import { Link } from "react-router-dom";
import { Quote } from "lucide-react";

const ASSET_BASE = `${process.env.PUBLIC_URL || ""}/assets`;

export default function OurStory() {
  return (
    <section className="py-16 md:py-24" data-testid="our-story-page">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <p className="text-xs tracking-[0.2em] uppercase text-holiday-red font-bold">Our Story</p>
        <h1 className="font-display text-5xl md:text-7xl leading-[0.95] mt-3">From one matka<br/>to <span className="text-holiday-red">every freezer</span><br/>in Gorakhpur.</h1>

        <div className="mt-12 grid md:grid-cols-12 gap-8 items-start">
          <div className="md:col-span-7 space-y-6 text-base md:text-lg leading-relaxed text-choc/85">
            <p><span className="font-serif text-3xl float-left mr-2 mt-1 text-holiday-red">I</span>n 1999, in a tin-roof workshop on Lachhipur Industrial Area, our family began boiling milk before sunrise. The recipe was old - slow-cooked, cardamom-scented, with crushed pista folded by hand. The vision was simple: make ice cream the way our grandmothers made it, and never compromise.</p>
            <p>26 years later, the workshop has become a parlour. The matkas have multiplied. We supply weddings in five districts, run a 24-hour counter, and ship bulk packs to schools and corporate events. But the recipe? The recipe still starts at 4am, with milk and patience.</p>
            <p>We are <strong>Holiday Ice Creams</strong>, a unit of <strong>Harsh Ice Company</strong> — and we believe a scoop should taste like a small holiday.</p>
          </div>
          <div className="md:col-span-5 space-y-4">
            <div className="aspect-[4/5] rounded-[2rem] overflow-hidden cushion border border-[#F0E4E4]">
              <video src={`${ASSET_BASE}/videos/scooping.mp4`} autoPlay loop muted playsInline className="w-full h-full object-cover"/>
            </div>
            <div className="grid grid-cols-2 gap-4">
              <div className="bg-ice-pink rounded-2xl p-4">
                <div className="font-display text-3xl text-holiday-red">1999</div>
                <div className="text-xs uppercase tracking-widest text-choc/70">Founded</div>
              </div>
              <div className="bg-mint rounded-2xl p-4">
                <div className="font-display text-3xl">24x7</div>
                <div className="text-xs uppercase tracking-widest text-choc/70">Always open</div>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-20 bg-sun-yellow-soft rounded-[2.5rem] p-8 md:p-14 relative cushion">
          <Quote className="w-10 h-10 text-holiday-red mb-4"/>
          <p className="font-serif italic text-2xl md:text-3xl leading-snug max-w-3xl">"We don't sell ice cream. We sell the five minutes you forget everything else."</p>
          <p className="mt-4 text-sm uppercase tracking-widest text-choc/70">- The Holiday family</p>
        </div>

        <div className="mt-16 text-center">
          <Link to="/products" className="inline-flex items-center gap-2 bg-choc text-cream px-7 py-4 rounded-full font-bold">Taste the catalogue</Link>
        </div>
      </div>
    </section>
  );
}



